import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  @service store;

  queryParams = {
    continuation: {
      refreshModel: true,
    },
    expand: {
      refreshModel: true,
      replace: true,
    },
  };

  model(params) {
    return this.store.query('backfill', params);
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.set('expanded', [controller.get('expand')].compact());
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('continuation', null);
      controller.set('expand', null);
    }
  }
}
